import { useEffect } from "react";
import { useAmn } from "../contexts/AmnContext"
import { useNavigate  } from "react-router-dom";
import { BaseRetorikConfig } from "../configs/retorikConfig";
import { generateUsername } from "../utils/globalUtils";
import { SessionState } from "../models/sessionState";

const HomePage = () => {
    const amn = useAmn();
    let navigate = useNavigate();

    //Handle old test date
    let oldTestDate : Date | undefined = undefined;
    if(localStorage.getItem("dateStart")){
        oldTestDate = new Date(JSON.parse(localStorage.getItem("dateStart")!));
    }

    const StartNewConversation = (modeTest : boolean = false) => {
        amn.setShowBot(true);
        let userName = BaseRetorikConfig.userData.name;
        let dateStart = new Date();
        localStorage.setItem("username",userName );
        localStorage.setItem("dateStart",JSON.stringify(dateStart));
        localStorage.setItem("retreiveHistory", JSON.stringify(false));
        amn.timer.retreive(true);
        if(modeTest){
            amn.setTestMode(true);
            userName = generateUsername(true);
            localStorage.setItem("username",userName);
            BaseRetorikConfig.userData.name = userName;
            BaseRetorikConfig.userData.username = userName;
            BaseRetorikConfig.userData.id = userName;
        }
        navigate("/amn");
    }

    const StartExistingConversation = () => {
        var username = prompt("Veuillez entrer le nom d'utilisateur :");

        // Vérifier si l'utilisateur a entré un nom d'utilisateur
        if (username) {
            var conversationId = prompt("Veuillez entrer le numéro de conversation :");
            if(conversationId){
                // Stocker le nom d'utilisateur dans le localStorage
                localStorage.setItem('username', username);
                localStorage.setItem("retreiveHistory", JSON.stringify(true));
                localStorage.setItem("conversationID", conversationId);
                amn.setConversationId(conversationId);
                BaseRetorikConfig.userData.name = username;
                BaseRetorikConfig.userData.username = username;
                BaseRetorikConfig.userData.id = username;
                amn.timer.retreive(true);
                amn.setShowBot(true);
                amn.setSessionState(SessionState.Retreived);
                navigate("/amn");
            }
            else{
                console.log("Aucun numéro de conversation n'a été saisi.");
            }
        } else {
            console.log("Aucun nom d'utilisateur n'a été saisi.");
        }
    }

    const RetreiveConversation = () => {
        amn.setShowBot(true);
        amn.setSessionState(SessionState.Retreived);
        let conversationId = localStorage.getItem("conversationID");
        if(conversationId){
            amn.setConversationId(conversationId)
        }
        localStorage.setItem("retreiveHistory", JSON.stringify(true));
        navigate("/amn");
    }

    const Export = () => {
        navigate("/export");
    }

    return (
        <main className="HomePage">
            <div className="HomeContainer">
                <h1>Formation à l’annonce d'une mauvaise nouvelle - V2</h1>
                <button onClick={() => StartNewConversation(false)}>Commencer une nouvelle session</button>
                {/* <button onClick={() => StartExistingConversation()}>Reprendre une conversation existante</button> */}
                <button onClick={() => StartNewConversation(true)}>Commencer une session en mode test</button>
                {/* {
                    amn.retreiveConversation && 
                    <div className="OldSession">
                        <p>Une session datant du {oldTestDate?.toLocaleDateString()} à {oldTestDate?.toLocaleTimeString().slice(0,5)} n'a pas été finalisée, voulez-vous la reprendre ?</p>
                        <button onClick={RetreiveConversation}>Reprendre la session en cours</button>
                    </div>
                } */}
                <button onClick={Export}>Exporter les données</button>
            </div>
        </main>
    )
}


export {
    HomePage
}